import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs/Rx';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { GUID } from "app/brightserve/brightserve.module";
import { Allergy, Medication, IncidentAdvice, IncidentDetail, IncidentFinding, MedicalHistory, AtmistData } from "app/shared/shared.module";

@Injectable()
export class AddonService {

    constructor(private http: HttpClient) { }

    GetAllergiesForPatient(Id: GUID): Observable<Allergy[]> {
        return this.http.get("/patient/" + Id + "/allergy/list")
            .map((res: any) => res.Allergys.map(a => new Allergy(a)) || {});
    };

    GetAllergiesList(): Observable<Allergy[]> {
        return this.http.get("/allergy/list")
            .map((res: any) => res.Allergys.map(a => new Allergy(a)) || {});
    };

    AddAllergyToPatient(Id:GUID, Allergy: Allergy): Observable<any> {
        return this.http.post("/patient/" + Id + "/allergy/add", { Allergy: Allergy})
            .map((res: any) => res || {});
    };

    RemoveAllergyToPatient(Id: GUID): Observable<any> {
        return this.http.delete("/allergy/" + Id)
            .map((res: any) => res || {});
    };

    GetMedicationsForPatient(Id: GUID): Observable<Medication[]> {
        return this.http.get("/patient/" + Id + "/medication/list")
            .map((res: any) => res.Medications.map(m => new Medication(m)) || {});
    }

    AddMedicationToPatient(Id: GUID, Medication: Medication): Observable<any> {
        return this.http.post("/patient/" + Id + "/medication/add", { Medication: Medication })
            .map((res: any) => res || {});
    };

    RemoveMedicationToPatient(Id: GUID): Observable<any> {
        return this.http.delete("/medication/" + Id)
            .map((res: any) => res || {});
    };

    GetMedicalHistoryForPatient(Id: GUID): Observable<any[]> {
        return this.http.get("/patient/" + Id + "/medicalhistory/list")
            .map((res: any) => res.MedicalHistory.map(m => m) || {});
    }

    AddMedicalHistoryToPatient(Id: GUID, MedicalHistory: MedicalHistory): Observable<any> {
        return this.http.post("/patient/" + Id + "/medicalhistory/add", { MedicalHistory: MedicalHistory })
            .map((res: any) => res || {});
    }

    GetIncidentTraumaDetails(Id: GUID): Observable<IncidentDetail[]> {
        return this.http.get("/incident/" + Id + "/detail/list")
            .map((res: any) => res.IncidentDetails.map(i => new IncidentDetail(i)) || {});
    }

    AddIncidentTraumaToIncident(Id: GUID, IncidentDetail: IncidentDetail): Observable<any> {
        return this.http.post("/incident/" + Id + "/detail/add", { IncidentDetail: IncidentDetail })
            .map((res: any) => res || {});
    };

    GetIncidentFindings(Id: GUID): Observable<IncidentFinding[]> {
        return this.http.get("/incident/" + Id + "/finding/list")
            .map((res: any) => res.IncidentFindings.map(i => new IncidentFinding(i)) || {});
    }

    AddIncidentFindingToIncident(Id: GUID, IncidentFinding: IncidentFinding): Observable<any> {
        return this.http.post("/incident/" + Id + "/finding/add", { IncidentFinding: IncidentFinding })
            .map((res: any) => res || {});
    };

    GetIncidentAdvice(Id: GUID): Observable<IncidentAdvice[]> {
        return this.http.get("/incident/" + Id + "/advice/list")
            .map((res: any) => res.IncidentAdvice.map(i => new IncidentAdvice(i)) || {});
    }

    AddIncidentAdviceToIncident(Id: GUID, IncidentAdvice: IncidentAdvice): Observable<any> {
        return this.http.post("/incident/" + Id + "/advice/add", { IncidentAdvice: IncidentAdvice })
            .map((res: any) => res || {});
    };

    GetATMISTData(Id: GUID): Observable<any> {
        return this.http.get("/incident/" + Id + "/atmist")
            .map((res: any) => new AtmistData(res) || {});
    };
}



// WEBPACK FOOTER //
// ./src/app/add-ons/addon.service.ts